<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/RQ6SUe/CoverDesign.jpg?1684979178822" alt="This image is the cover for the book Downpayment"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Downpayment
      </h1>
      <p class="bookDescription body article font2">
        <p>Mike Barrow and his friends are among many boys in Manchester who think the city will be their chance to improve themselves. But for now Mike is living in a damp flat with his friend Callum, and they’re both making ends meet by working the streets. When Mike meets Chris Wildsmith, a late-twenties entrepreneur, he thinks he’s hooked a job that will pay his rent for several weeks—a windfall already.</p><p>But his connection with Chris quickly goes beyond what’s normal between rent boy and client. Mike meets Chris’s friends, goes to Chris’s parties with him as his “boyfriend,” and finds himself swept up in a world he’s never known. He’s sure it’s all going to go horribly wrong, and when Chris’s work colleague figures them out and becomes violent, he’s almost proven right. But Mike isn’t the only one who has confused professionalism with something else. The breakup that follows gives Mike the impetus he needs to relaunch himself as somebody else, a man who will hopefully be someone Chris very much wants to be with.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        AJ Mars
      </h2>
      
      <p class="authorDescription body article"><P>AJ Mars is a midtwenties wanderer who&rsquo;s lived everywhere from New Mexico to New Zealand, via half of Western Europe. Her writing reflects her love of travel, although she&rsquo;s now fairly settled in the UK with her partner and their cats. AJ has a PhD in a useless subject and a passionate interest in Shakespeare. She teaches creative writing and literature classes and tries her best to practice what she preaches.</P></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Dreamspinner Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?049fecf8